<template>
  <div class="row row-space-4 mt-2">
    <div class="col-md-6 align-self-center">
      <div class="p-4">
        <img src="@/assets/img/welcome.svg" class="img-fluid" />
      </div>
    </div>
    <div class="col-md-6 align-self-center">
      <h1 class="h4 mb-3">Welcome {{shopObj.name}}</h1>
      <div class="mb-3">
        <button class="btn btn-lg btn-primary" @click="next">Continue &rsaquo;</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState([ 'shopObj' ]),
  methods: {
    next: function () {
      this.$store.commit('NEXT_STEP')
      this.$router.replace({ name: 'setup_amp' })
    }
  }
}
</script>
